import { inject, Injectable } from '@angular/core';
import { Observable, throwError, filter } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { InsuranceType } from '../../models/insurance-type';
import { InsurenetInterfaceService } from '../insurenet-interface/insurenet-interface.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { ProductsService } from 'app/products/products.service';
import { toShareable } from '@co-3/ctrl-ui/common';

@Injectable({
    providedIn: 'root',
})
export class InsuranceTypesService {
    private insurenetInterface = inject(InsurenetInterfaceService);
    private insuranceTypesShareable = toShareable(() => this.insurenetInterface.getInsuranceTypes());

    public insuranceType$ = inject(ProductsService).product$.pipe(
        filter((product) => product != null),
        switchMap((product) => this.get(product.insuranceTypeId)),
    );
    public insuranceType = toSignal(this.insuranceType$);

    public get(insuranceTypeId: number): Observable<InsuranceType | null> {
        return this.insuranceTypesShareable().pipe(
            map((insuranceTypes) => {
                const insuranceType = this.find(insuranceTypes, 'id', insuranceTypeId);
                if (!insuranceType) {
                    throwError(() => new Error(`No InsuranceType found for the following id: ${insuranceTypeId}`));
                }
                return insuranceType;
            }),
        );
    }

    private find(insuranceTypes: InsuranceType[], key: string, value: string | boolean | number): InsuranceType | null {
        return insuranceTypes.find((item) => item[key] === value) || null;
    }
}
